import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AccountClientDetailsService } from '../../../service/account-client-edit/account-client-details.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from "ng2-bootstrap-modal";
import { InsertGuaranteeModalComponent } from './../../account-client-details/guarantees-account-client/insert-guarantee-account-client/insert-guarantee-modal.component';
import { GuaranteeType } from '../../../../models/guarantee-type';
import { GuaranteeStatus } from '../../../../models/guarantee-status';

import * as moment from 'moment';
import 'moment/locale/pt-br';

@Component({
	selector: 'app-guarantees-account-client',
	templateUrl: './guarantees-account-client.component.html'
})
export class GuarantessAccountClientComponent implements OnInit {

	@Input('client') client: any[] = [];

	public guid: string;
	private sub: any;
	private cartaFiancaRecebida: any[] = [];
	private cartaFiancaFornecida: any[] = [];
	private hipoteca: any[] = [];
	private alienacaoBensMoveis: any[] = [];
	private alienacaoBensImoveis: any[] = [];
	private penhor: any[] = [];
	private cessaoCredito: any[] = [];
	private CPR: any[] = [];
	private outros: any[] = [];
	public guaranteeType: GuaranteeType;
	public guaranteeStatus: GuaranteeStatus;
	public permissoes: any[] = [];

	constructor(private accountClientDetailsService: AccountClientDetailsService, private dialogService: DialogService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.guaranteeType = new GuaranteeType();
		this.guaranteeStatus = new GuaranteeStatus();
		this.getGuarantees();
	}

	insertGuarantee(proposalID, proposalCod) {
		let disposable = this.dialogService.addDialog(InsertGuaranteeModalComponent, {
			client: this.client,
			guaranteeObj: null
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.getGuarantees();
				}
				else {
					//Do nothing here for now
				}
			});
	}

	editGuarantee(obj) {
		let disposable = this.dialogService.addDialog(InsertGuaranteeModalComponent, {
			client: this.client,
			guaranteeObj: obj
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.getGuarantees();
				}
				else {
					//Do nothing here for now
				}
			});
	}

	getGuarantees() {

		this.cartaFiancaRecebida = [];
		this.cartaFiancaFornecida = [];

		var doc = this.client['Documento'].replace(/[^\d]+/g, '');

		if (doc.length == 10 || doc.length == 11 || doc.length == 14) {
			this.accountClientDetailsService.getGuarantees(doc).subscribe(result => {
				if (result.Success) {
	
					var cartaFianca = result.Result.filter(item => item.TipoGarantia === "1");
	
					for (var carta in cartaFianca) {
						var objCarta = cartaFianca[carta];
	
						for (var part in cartaFianca[carta].ParticipanteGarantia) {
							var objPart = cartaFianca[carta].ParticipanteGarantia[part];
	
							if (objPart.Documento === this.client['Documento']) {
								if (objPart.Garantido) {
									this.cartaFiancaRecebida.push(objCarta);
								} else {
									this.cartaFiancaFornecida.push(objCarta);
								}
							}
						}
					}
	
					this.hipoteca = result.Result.filter(item => item.TipoGarantia === "2");
					this.alienacaoBensMoveis = result.Result.filter(item => item.TipoGarantia === "3");
					this.alienacaoBensImoveis = result.Result.filter(item => item.TipoGarantia === "4");
					this.penhor = result.Result.filter(item => item.TipoGarantia === "5");
					this.cessaoCredito = result.Result.filter(item => item.TipoGarantia === "6");
					this.CPR = result.Result.filter(item => item.TipoGarantia === "7");
					this.outros = result.Result.filter(item => item.TipoGarantia === "8");
	
					$('html, body').animate({ scrollTop: $(".guarantee-tab").offset().top - 20 }, 500);
	
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	removeGuarantee(garantia) {
		garantia.Ativo = false;

		this.accountClientDetailsService.updateClientGuarantee(garantia).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Garantia Removida", { cssClass: 'alert-success', timeout: 6000 });
				this.getGuarantees();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/guarantees-account-client/guarantees-account-client.component.ts